import React from 'react';

const ModalFooter = ({ onSubmit, disabled = false }) => {
	return (
		<div className="modal-footer">
			<div className="footer-buttons text-right">
				<button type="button" className="button size32 ml-2" onClick={onSubmit} disabled={disabled}>
					Submit
				</button>
			</div>
		</div>
	);
};

export default ModalFooter;
